/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import RoleRepresentation, { RoleMappingPayload } from '@keycloak/keycloak-admin-client/lib/defs/roleRepresentation';

export interface User {
  id?: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  enabled: boolean;
  groups: string[];
  groupIds?: string[];
  clientRoles: ClientRoles;
}

export interface ClientRoles {
  alfa: string[];
  admin: string[];
}

export interface Profile {
  name: string;
  initials: string;
  username: string;
  email: string;
  roles: string[];
}

export interface ClientMapping {
  mappings: RoleRepresentation[];
}

export interface RoleMappings {
  newClientRoleMappings: RoleMappingPayload[];
  oldClientRoleMappings: RoleMappingPayload[];
}

export enum AuthClient {
  ADMIN = 'admin',
  ALFA = 'alfa',
}

export enum AdminRoles {
  ADMIN = 'ADMIN_ADMIN',
  DATENBEAUFTRAGUNG = 'DATENBEAUFTRAGUNG',
}

export enum AlfaRoles {
  ADMIN = 'ADMIN_ADMIN',
  LOESCHEN = 'VERWALTUNG_LOESCHEN',
  USER = 'VERWALTUNG_USER',
  POSTSTELLE = 'VERWALTUNG_POSTSTELLE',
  TECH_USER = 'TECH_USER',
}

export const OTP_CREDENTIAL_TYPE: string = 'otp';

export const UNNAMED_DEVICE_LABEL: string = 'Unbenanntes Gerät';

export interface UserCredential {
  id: string;
  type: string;
  userLabel?: string;
  createdDate: number;
  credentialData?: string;
}

export interface UserCredentialMetadata {
  credential: UserCredential;
}

export interface UserCredentialWrapper {
  type: string;
  category: string;
  displayName: string;
  helptext: string;
  iconCssClass?: string;
  updateAction?: string;
  removeable: boolean;
  userCredentialMetadatas: UserCredentialMetadata[];
}

export interface DeviceLabelUpdate {
  credentialId: string;
  label: string;
}
